// Module
var code = `<div id="internet-check">
  <div class="alert alert--danger" ng-hide="\$ctrl.datesOk">
    System date does not match current date. Please adjust system date before performing any transaction.
  </div>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/technical/system-date-validation/system-date-validation.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;